<style lang="scss" scoped></style>

<template>
  <td>
    <div @click="takeDialog()" class="btn btn-primary">Nehmen / zum Chat</div>
  </td>
</template>

<script lang="babel">
export default {
    props: ['model'],
    methods: {
      takeDialog() {
        this.$http
          .post(`/api/v1/moderation/take/${this.model.id}`)
          .then(() => {
            this.$attrs.attribute.event ? this.$bus.$emit(this.$attrs.attribute.event): null;
          });
      }
    }
};
</script>
